<template>
  <div class="show">
    <template v-if="wxdata">
      <el-avatar
        class="headpic"
        :size="60"
        :src="wxdata.headpic || $common.getResourceUrl('logo.png')"
      />
      <div class="nickname">{{ wxdata.nickname || '微信用户' }}</div>
    </template>
    <template v-else>
      <el-avatar
        class="headpic"
        :size="60"
        :src="$common.getResourceUrl('logo.png')"
      />
    </template>
    <div class="state">
      <i v-if="type" class="icon" :class="type"></i>
      <i v-else class="icon el-icon-loading"></i>
      <span class="text">{{ text }}</span>
    </div>

    <!-- <div v-if="type == 'bindcel'" class="bindcel-btn">
      <el-button type="primary" @click="changeType"
        >去登录并绑定该微信</el-button
      >
    </div> -->
  </div>
</template>

<script>
import { doWxLogin } from '@/network/request'
export default {
  name: 'Wxback',
  data() {
    return {
      loading: false,
      type: '', // chahao success bindcel
      text: '',
      wechatToken: '',
      wxdata: null,
    }
  },
  beforeCreate() {
    document
      .querySelector('body')
      .setAttribute('style', 'background-color: #ffffff;')
    const styleNode = document.createElement('style')
    styleNode.setAttribute('id', 'msg-hide')
    styleNode.setAttribute('type', 'text/css')
    styleNode.innerHTML = '.el-message{ display: none !important; } '
    document.querySelector('head').appendChild(styleNode)
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
    document.getElementById('msg-hide').remove()
  },
  created() {},
  mounted() {
    const query = this.$route.query
    this.wechatToken = query.wechat_token
    if (this.wechatToken && parent.setWechatToken && parent.loginSuccess) {
      this.wxdata = {
        nickname: query.nickname || '',
        headpic: query.headpic || '',
        sex: query.nicknamsexe || '',
      }
      parent.setWechatToken(this.wechatToken)
      this.wechatLogin()
    } else {
      this.type = 'el-icon-warning-outline'
      this.text = '参数错误'
    }
  },
  methods: {
    changeType() {
      parent.changeType()
    },
    wechatLogin() {
      this.type = ''
      this.text = '登录中...'
      doWxLogin({ wechatToken: this.wechatToken })
        .then(() => {
          this.loading = false
          this.type = 'el-icon-circle-check'
          this.text = '登录成功'
          parent.loginSuccess()
        })
        .catch((e) => {
          if (e.data.code === 30002) {
            this.type = 'el-icon-back'
            this.text = '未绑定账户，使用手机号登录'
          } else {
            this.type = 'el-icon-warning-outline'
            this.text = e.data.msg
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.show {
  width: 222px;
  height: 210px;
  text-align: center;
  background: #fff;
  color: #909399;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.headpic {
  margin-bottom: 20px;
}
.nickname {
  font-size: 16px;
  margin-bottom: 55px;
}

.state {
  margin-bottom: 10px;
  .icon {
    margin-right: 4px;

    &.el-icon-circle-check {
      color: #67c23a;
    }
    &.el-icon-warning-outline {
      color: #ff4d4d;
    }
  }
  .text {
    font-size: 13px;
  }
}

.bindcel-btn {
  margin-top: 40px;
}
</style>
